import React from "react";
import { useCase } from "../../../../contexts/CaseContext";
import { Subheading } from "../../../../design/heading";
import { Text } from "../../../../design/text";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import CreateChildButton from "./components/CreateChildButton";
import { Avatar } from "../../../../design/avatar";
import { calculateAgeUTC } from "../../../../utils/date";

interface Props {
  caseId: string;
}

const CaseDetailChildList: React.FC<Props> = ({ caseId }) => {
  const { childList } = useCase();
  return (
    <>
      <div className="flex flex-wrap items-center justify-between w-full">
        <Subheading>Children</Subheading>
        <div className="flex gap-4">
          <CreateChildButton caseId={caseId} />
        </div>
      </div>
      {childList.length === 0 && (
        <div className="py-8 text-center">
          <p className="text-sm text-zinc-500 dark:text-zinc-400">No children have been added yet.</p>
          <Text className="text-xs text-zinc-400 dark:text-zinc-500">Required before scheduling a visit.</Text>
        </div>
      )}
      {childList.length > 0 && (
        <Table className="mt-4 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Age</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {childList.map((child) => {
              const age = calculateAgeUTC(child.dob);
              return (
                <TableRow
                  key={child.id}
                  title={`Child ${child.id}`}
                  href={`/child/${child.id}`}
                >
                  <TableCell>
                    <Avatar
                      src={child.avatarUrl}
                      className="mr-2 align-middle size-6"
                      initials={`${child.firstName?.[0] ?? ""}${child.lastName?.[0] ?? ""}`}
                    />
                    {child.firstName} {child.lastName}
                  </TableCell>
                  <TableCell>{age}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default CaseDetailChildList;
